import React from "react";

import { statesByCountryCode } from "../utils/states";
import AutocompleteField from "../AutocompleteField";
import TextField from "../TextField";
import { StateFieldProps } from "./StateField.types";

function StateField(props: StateFieldProps) {
  const { countryCode, ...other } = props;

  let states;

  if (countryCode) {
    states = statesByCountryCode[countryCode];
  }

  if (states) {
    const options = states.map((state) => state.name);
    return <AutocompleteField {...other} options={options} />;
  }

  return <TextField {...other} />;
}

export default StateField;
